import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { observer, inject } from 'mobx-react';
import HierTable from '../../../HierTable';
import Spinner from "../../../Spinner";
import Form, { DateInput, FormActions, FormBody, SelectInput } from '../../../Form';
import { action, observable, toJS } from 'mobx';
import moment from 'moment';
import FormMultiSelectInput from "../../../../components/FormMultiSelectInput";
import { SwitchInput } from "../../../Form";
import { token } from '../../../../libs/localStorage';
import { getDisplayDate } from '../../../../libs/date';

@inject('surveyStore', 'stationStore', 'surveyTemplateStore', 'surveyTopicStore', 'userStore', "locationStore", "locationTypeStore", "ticketStore", 'reportingTemplateStore')
@observer
class SurveyHistory extends Component {
  static propTypes = {
    params: PropTypes.shape().isRequired,
    route: PropTypes.shape().isRequired,
    children: PropTypes.node,
  }

  static contextTypes = {
    notify: PropTypes.shape().isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      filteredData: [],
    };
    this.unfilteredData = [];
  }

  @observable multiStationOptions = [];
  @observable filters = {
    station_id: "",
    date_from: moment().add(-6, 'days').format('YYYY-MM-DD'),
    date_to: moment().format('YYYY-MM-DD'),
    filter_by_location: false,
    location_id: 0,
    location_type_id: 0,
  }

  @observable prevFilters = {
    station_id: "",
    date_from: moment().add(-6, 'days').format('YYYY-MM-DD'),
    date_to: moment().format('YYYY-MM-DD'),
    filter_by_location: false,
    location_id: 0,
    location_type_id: 0,
  };


  @observable selectedStations = [];
  @action onChangeFilters = (e, key) => {
    this.filters[key] = e.target.value;
    if (key === 'location_type_id') this.filters.location_id = 0;
  }

  @action onChangeSelectedStations = items => {
    this.selectedStations = items;
  }

  onStationSelect = (item) => {
    item.value = !item.value;
    // this.onView();
  };


  componentWillMount() {
    const { stationStore, surveyTemplateStore, surveyTopicStore, userStore, ticketStore } = this.props;
    if (!stationStore.isLoading && !stationStore.items.length) stationStore.fetchItems();
    if (!surveyTemplateStore.isLoading && !surveyTemplateStore.items.length) surveyTemplateStore.fetchItems();
    if (!surveyTopicStore.isLoading && !surveyTopicStore.items.length) surveyTopicStore.fetchItems();
    if (!userStore.isLoading && !userStore.items.length) userStore.fetchItems();
    if (!ticketStore.isLoading && !ticketStore.items.length) ticketStore.fetchItems();
  }

  componentDidMount() {
    const { locationStore, locationTypeStore } = this.props;
    if (!locationStore.items.length && !locationStore.isLoading) locationStore.fetchItems();
    if (!locationTypeStore.items.length && !locationTypeStore.isLoading) locationTypeStore.fetchItems();
    this.populateOptions();
  }

  componentDidUpdate() {
    // const { location_type_id, location_id } = this.filters;
    // const { location_type_id: prevLocationTypeId, location_id: prevLocationId } = this.prevFilters;
    // if (prevLocationTypeId !== location_type_id || prevLocationId !== location_id) { this.onView() }
    this.prevFilters = { ...this.filters };
  }

  populateOptions = () => {
    const { stationStore } = this.props;
    if (stationStore.items.length === 0) {
      setTimeout(() => {
        this.populateOptions();
      }, 300);
    } else {
      this.multiStationOptions = stationStore.items.map((item) => ({
        id: item.id,
        name: item.name,
        label: item.name,
        value: true,
        tags: item.tags,
      }));
      this.onChangeSelectedStations(
        stationStore.items.map((item) => +item.id)
      );
    }
  };

  handleDelete = (idOrIds) => {
    this.props.surveyStore.removeItems(idOrIds);
  }

  slug = 'monitoring/survey/history';
  columns = [
    // { key: 'id', label: 'ID' },
    { key: 'station', label: 'Station', sortable: true },
    { key: 'topic', label: 'Topic' },
    { key: 'response', label: 'Response' },
    { key: 'visitor', label: 'Visited By' },
    { key: 'creator', label: 'Created By' },
    { key: 'date_visited', label: 'Date Visited', sortable: true },
    { key: 'date_created', label: 'Date Created', sortable: true },
    { key: 'ticket_creation_date', label: 'Ticket Creation Date', sortable: true },
    { key: 'ticket_end_date', label: 'Ticket End Date', sortable: true },
    { key: 'view', label: '' },
    { key: 'edit', label: '' },
    { key: 'delete', label: '' },
  ];

  flattenItems = items => {
    const { stationStore, surveyTopicStore, userStore, ticketStore } = this.props;
    let data = [];

    items && items
      .sort((a, b) => moment(b.date_visited) - moment(a.date_visited))
      .forEach((item) => {
        const station = stationStore.findById(item.station_id);
        const visitor = userStore.findById(item.visitor_user_id);
        const creator = userStore.findById(item.creator_user_id);
        const ticket = ticketStore.findById(item.ticket_id);
        data.push({
          key: `topic-${item.id}`, // slug: this.slug,
          type: 'TOPIC', level: 1, id: item.id,
          date_visited: item.date_visited,
          date_created: item.date_created,
          ticket_creation_date: ticket ? getDisplayDate(ticket.generated_date) : '',
          ticket_end_date: (ticket && ticket.end_date) ? getDisplayDate(ticket.end_date) : '',
          station: !!station ? station.name : 'Invalid Station',
          visitor: !!visitor ? visitor.name : 'Invalid User',
          creator: !!creator ? creator.name : 'Invalid User',
          view: <Link to={`${this.slug}/${item.id}`}>View</Link>,
          edit: (creator && (+creator.id === +token.getDecoded().id)) ? <Link to={`/${this.slug}/edit/${item.id}`}>
            <i className="fa fa-pencil" aria-hidden="true" />
          </Link> : null,
          delete: (creator && (+creator.id === +token.getDecoded().id)) ? <a onClick={() => this.deleteItem(item.id)}>
            <i className="fa fa-trash" aria-hidden="true" />
          </a> : null
        });
        if (!!item.responses && !!item.responses.length) item.responses.forEach(response => {
          const topic = surveyTopicStore.findById(response.topic_id);
          data.push({
            key: `topic-${item.id}-response-${response.id}`,
            type: 'RESPONSE', level: 2, parent_id: item.id, id: response.id,
            topic: !!topic ? topic.name : 'Invalid Topic',
            response: surveyTopicStore.resolveValue(response.topic_id, response.value),
          })
        });
      });

    return data;

  }

  deleteItem = id => {
    const { notify } = this.context;
    const { surveyStore } = this.props;
    /*global event, fdescribe*/
    /*eslint no-restricted-globals: ["error", "event", "fdescribe"]*/
    if (confirm('Delete?')) {
      surveyStore.removeItems(id)
        .then(() => notify.success({ message: 'Deleted' }))
        .catch(err => {
          console.log(err);
          notify.error({ message: err.toString() })
        });
    }
  }

  @action exportPDF = (e, format, item, items) => {
    const { surveyTemplateStore, stationStore, userStore, ticketStore, reportingTemplateStore } = this.props;
    e.preventDefault();
    let csv = [
      "S.NO,STATION,DIVISION,DISTRICT,SURVEY TEMPLATE,VISITED BY,CREATED BY,DATE VISITED,DATE CREATED, TICKET CREATION DATE",
    ];

    let toDownload = item;

    items.filter((item) => toDownload
      .some((toDownloadValue) => toDownloadValue.id === item.id))
      .sort((a, b) => moment(b.date_visited) - moment(a.date_visited))
      .forEach((item, i) => {
        const station = stationStore.findById(item.station_id);
        const division = !!station && !!station.meta_data && station.meta_data.find((item) => item.name === "Division");
        const district = !!station && !!station.meta_data && station.meta_data.find((item) => item.name === "District");
        const surveyTemplate = surveyTemplateStore.findById(item.survey_template_id);
        const ticket = ticketStore.findById(item.ticket_id);
        const visitor = userStore.findById(item.visitor_user_id);
        const creator = userStore.findById(item.creator_user_id);
        csv.push([
          i + 1,
          station.name,
          !!division ? division.value : '',
          !!district ? district.value : '',
          !!surveyTemplate ? surveyTemplate.name : '',
          !!visitor ? visitor.name : '',
          !!creator ? creator.name : '',
          item.date_visited,
          item.date_created,
          ticket ? getDisplayDate(ticket.generated_date) : '',
        ])
      })

    reportingTemplateStore.downloadReport(
      csv.join("\n"),
      format,
      { orientation: "Landscape", report_name: `Maintenance Reports from ${this.filters.date_from} to ${this.filters.date_to}` }
    );
  };

  _renderLocationFilterIinputs = () => {
    const { locationStore, locationTypeStore } = this.props;
    return (
      <div>
        <SelectInput label="Location Type" value={this.filters.location_type_id} options={[{ id: 0, name: "All" }, ...locationTypeStore.items]}
          isLoading={locationTypeStore.isLoading} onChange={(e) => this.onChangeFilters(e, "location_type_id")} fields={{ label: "name", value: "id" }} />
        {this.filters.location_type_id !== 0 && (
          <SelectInput label="Location" value={this.filters.location_id}
            options={[{ id: 0, name: "All" }, ...locationStore.items.filter((item) => item.type_id === this.filters.location_type_id),]}
            isLoading={locationStore.isLoading} onChange={(e) => this.onChangeFilters(e, "location_id")} fields={{ label: "name", value: "id" }} />
        )}
      </div>
    );
  };


  resetFormValues = () => {
    this.filters.station_id = "";
    this.filters.date_from = moment().add(-6, 'days').format('YYYY-MM-DD');
    this.filters.date_to = moment().format('YYYY-MM-DD');
    this.filters.location_id = 0;
    this.filters.location_type_id = 0;
  };

  toggleFilterByLocation = () => {
    this.filters.filter_by_location = !this.filters.filter_by_location;
    this.resetFormValues();
    // this.onView();
  };

  onView = async (e) => {
    if (e) {
      e.preventDefault();
    }
    const { surveyStore, stationStore, locationStore } = this.props;
    const { filters } = this;

    let data = await surveyStore.fetchItems(filters);

    this.unfilteredData = data;

    if (!filters.filter_by_location) {
      const selectedStationIds = this.multiStationOptions
        .filter((item) => !!item.value)
        .map((item) => +item.id);

      if (selectedStationIds.length > 0 && data) {
        data = data.filter((item) =>
          selectedStationIds.includes(item.station_id)
        );
      }
    } else {
      if (filters.location_type_id !== 0 && filters.location_id !== 0 && data) {
        data = data.filter((item) => {
          const station = stationStore.findById(item.station_id);
          return locationStore.isPartOf(station.location_id, this.filters.location_id);
        });
      }
    }

    this.setState({ filteredData: data });
  };


  render() {
    const {
      surveyStore,
      stationStore,
      surveyTopicStore,
      userStore,
      children,
    } = this.props;

    let isLoading =
      surveyStore.isLoading ||
      stationStore.isLoading ||
      surveyTopicStore.isLoading ||
      userStore.isLoading;
    if (!!children) return children;

    const data = this.flattenItems(this.state.filteredData) //.sort((a, b) => moment(a.date_visited) - moment(b.date_visited)).map((item, index) => ({ ...item, sn: index + 1 }));
    return (
      <div>
        <Form>
          <FormBody>
            <SwitchInput label="Filter By Location" value={this.filters.filter_by_location} onChange={() => { this.toggleFilterByLocation(); }} />
            {!this.filters.filter_by_location && (
              <FormMultiSelectInput id="station-multi-select" label="Stations" options={this.multiStationOptions} optionClicked={this.onStationSelect} isLoading={stationStore.isLoading} filterOptions={stationStore.filterStations} />
            )}
            {this.filters.filter_by_location && this._renderLocationFilterIinputs()}
            <DateInput type={"date"} label={"Date From"} value={this.filters.date_from} onChange={(e) => this.onChangeFilters(e, "date_from")} />
            <DateInput type={"date"} label={"Date To"} value={this.filters.date_to} onChange={(e) => this.onChangeFilters(e, "date_to")} />
          </FormBody>
          <FormActions>
            <button onClick={this.onView}>View</button>
            <button
              className="button"
              onClick={(e) => this.exportPDF(e, "PDF", data, surveyStore.items)}
            >
              Print
            </button>
          </FormActions>
        </Form>
        {surveyStore.items.length > 0 && (
          <HierTable
            data={data}
            slug={this.slug}
            columns={this.columns}
            onDelete={this.handleDelete}
            // allowAdd
            // allowEdit
            // allowDelete
            resources={{ parent: "maintenance", child: "maintenance" }}
            searchable={true}
            showSerialNo={true}
          />
        )}
        {isLoading && <Spinner />}
      </div>
    );
  }
}


export default SurveyHistory;




// WEBPACK FOOTER //
// ./src/components/Maintenance/Survey/Survey/SurveyHistory.js